import { useRouter } from 'next/router';
import { useRef, useState } from 'react';

import './Content.scss';
import Button from '../Button/Button';
import icons from '../../../shared/assets/icons/redesign';

const { Logo, Copy } = icons;

export default function Content({ code }) {
  const codeRef = useRef();
  const router = useRouter();
  const [copied, setCopied] = useState(false);

  return (
    <div className="componentWrap">
      <div className="videoland">
        <Logo className="videoland-zp-logo" />

        {code ? (
          <>
            <div className="videoland-title-wrap">
              <img
                className="videoland-bg-img"
                src="https://upr.io/dWr79P.webp"
              />

              <h1 className="videoland-title">
                Gefeliciteerd! Hier is jouw unieke code.
              </h1>
            </div>

            <div className="videoland-code">
              <span ref={codeRef}>{code}</span>
              {copied ? (
                <span className="videoland-code-icon videoland-text">
                  Copied!
                </span>
              ) : (
                <Copy
                  onClick={(e) => copy(e)}
                  className="videoland-code-icon cursor-pointer"
                />
              )}
            </div>

            <Button
              label="Verzilver jouw code bij Videoland"
              onClick={() => (location.href = 'https://www.videoland.com/code')}
            />

            <a
              href="https://hulp.videoland.com/article/actievoorwaarden-zwangerenportaal"
              target="_blank"
              rel="noopener noreferrer"
              className="videoland-link"
            >
              Bekijk de actievoorwaarden
            </a>

            <p className="videoland-text-bold">
              Volg deze eenvoudige stappen om je code te verzilveren en te
              geniet van je maand <span className="nowrap">Videoland Plus</span>{' '}
              cadeau:
            </p>

            <ul className="videoland-list">
              <li className="videoland-list-item">
                <span className="videoland-list-item-marker">1</span>
                <span>
                  Vul de code in op{' '}
                  <a
                    rel="noopener noreferrer"
                    className="videoland-list-item-link"
                    href="https://www.videoland.com/code"
                  >
                    https://www.videoland.com/code
                  </a>{' '}
                  en krijg 1 maand{' '}
                  <span className="nowrap">Videoland Plus</span> cadeau.
                </span>
              </li>

              <li className="videoland-list-item">
                <span className="videoland-list-item-marker">2</span>
                Maak binnen een paar klikken je account aan en begin meteen met
                kijken.
              </li>

              <li className="videoland-list-item">
                <span className="videoland-list-item-marker">3</span>
                <span>
                  Installeer de app op je telefoon, tablet of smart TV en kijk
                  waar en wanneer je wilt.
                </span>
              </li>
            </ul>

            <div className="videoland-footer bold text-center">
              <p className="videoland-footer-text">
                We hopen dat je geniet van je me-time met{' '}
                <span className="nowrap">Videoland Plus</span> en wensen je een
                fijne verlofperiode toe!
              </p>

              <Button
                label="Verzilver jouw code bij Videoland"
                onClick={() =>
                  (location.href = 'https://www.videoland.com/code')
                }
              />
            </div>
          </>
        ) : (
          <>
            <h1 className="videoland-title">
              Geniet van jouw welverdiende me-time met 1 maand gratis{' '}
              <span className="nowrap">Videoland Plus!</span>
            </h1>

            <img src="https://upr.io/dWr79P.webp" hidden />

            <p className="videoland-text">
              Eindelijk, je verlofperiode komt eraan! Voordat je het weet, houd
              je jouw kindje in je armen. Deze prachtige periode zal zeker druk
              zijn. Daarom verdien je nu wat me-time! Wij geven je 1 maand{' '}
              <span className="nowrap">Videoland Plus</span> cadeau. Kun je niet
              wachten tot je verlof begint? Verzilver je voucher meteen!
            </p>

            <Button
              label="Ontvang jouw unieke code"
              onClick={() => router.push('/videoland-code')}
            />

            <a
              href="https://hulp.videoland.com/article/actievoorwaarden-zwangerenportaal"
              target="_blank"
              rel="noopener noreferrer"
              className="videoland-link"
            >
              Bekijk de actievoorwaarden
            </a>

            <img
              className="videoland-left-img"
              src="https://upr.io/pwq2bP.webp"
              alt="videoland-image"
            />
            <img
              className="videoland-right-img"
              src="https://upr.io/A3gnNA.webp"
              alt="videoland-image"
            />
          </>
        )}
      </div>
    </div>
  );

  function copy(e) {
    navigator.clipboard.writeText(codeRef.current.innerText);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  }
}
